const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgR5Compact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.011,
    height: 67.562,
    viewBox: "0 0 14.82 17.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "23.2816px",
      lineHeight: 1.15,
      fontFamily: "Avenir",
      InkscapeFontSpecification: "Avenir",
      letterSpacing: 0,
      opacity: 1,
      strokeWidth: 0.264999,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "m123.033 26.592-.008.091a600.23 600.23 0 0 0-.43 5.34l-.01.108h.935l.03-.031c.275-.295.599-.508.972-.643a3.456 3.456 0 0 1 1.162-.205c.397 0 .746.064 1.051.186.307.122.562.29.768.51v.001c.213.22.374.475.484.775.11.3.166.63.166.989 0 .346-.053.686-.158 1.02-.099.326-.254.62-.47.884a2.393 2.393 0 0 1-.816.623c-.32.157-.707.238-1.16.238-.272 0-.53-.034-.775-.101a2.363 2.363 0 0 1-.654-.319 1.883 1.883 0 0 1-.49-.553 2.37 2.37 0 0 1-.284-.806l-.015-.084h-1.047l.014.113c.058.437.18.83.365 1.172l.002.002c.19.335.427.619.71.85l.003.002c.29.224.62.394.986.512.367.118.762.178 1.186.178.59 0 1.11-.094 1.558-.286h.002a3.163 3.163 0 0 0 1.113-.798c.302-.342.526-.744.67-1.201v-.002c.15-.457.225-.949.225-1.473 0-.47-.082-.913-.246-1.326a3.287 3.287 0 0 0-.68-1.073 3.048 3.048 0 0 0-1.026-.73 3.094 3.094 0 0 0-1.283-.266c-.194 0-.396.01-.609.03-.215.02-.428.055-.637.107a2.627 2.627 0 0 0-.613.217c-.123.059-.223.15-.33.23l.322-3.318h4.596v-.963zm-3.822 6.84c-1.444 0-2.608.722-3.423 2.165-.047-.256-.07-1.07-.093-1.885h-1.397c0 .186.116 2.677.116 2.91v7.846h1.397V38.6c0-2.235 1.234-3.771 3.493-3.771.186 0 .372.023.558.093l.163-1.374a2.747 2.747 0 0 0-.814-.117z",
    transform: "translate(-114.298 -26.592)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR5Compact);
export default __webpack_public_path__ + "static/media/r5_compact.21874a79635709765491d0bff965eae1.svg";
export { ForwardRef as ReactComponent };